import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c0160f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "widget-calendar" }
const _hoisted_2 = {
  key: 0,
  class: "widget-calendar__container"
}
const _hoisted_3 = { class: "widget-calendar__container__content" }
const _hoisted_4 = {
  key: 1,
  class: "widget-calendar__container__content__timeline"
}
const _hoisted_5 = {
  key: 2,
  class: "widget-calendar__container__content__timeline"
}
const _hoisted_6 = {
  key: 1,
  class: "widget-calendar__container__content__timeline"
}
const _hoisted_7 = {
  key: 2,
  class: "widget-calendar__container__content__no-availability"
}
const _hoisted_8 = {
  key: 1,
  class: "widget-calendar__container widget-calendar__container--fallback"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 1,
  class: "widget-calendar__container widget-calendar__container__logo"
}
const _hoisted_11 = ["href"]

import { computed, PropType, ref, watch } from 'vue'
import { CalendarType } from '@/models/google.model'
import CalendarHeader from '@/components/overview-calendar/CalendarHeader.vue'
import CalendarToolbar from '@/components/overview-calendar/CalendarToolbar.vue'
import { useBreakpoints } from '@/composables/useBreakpoints'
import WidgetMonth from '@/components/booking-widget/WidgetMonth.vue'
import isAfter from 'date-fns/isAfter'
import eachDayOfInterval from 'date-fns/eachDayOfInterval'
import {
  CompanyHousingDateAvailability,
  MinimumTimeslot,
} from '@/models/public/service.model'
import WidgetDay from '@/components/booking-widget/WidgetDay.vue'
import { differenceInMinutes } from 'date-fns'
import _ from 'lodash'
import startOfDay from 'date-fns/startOfDay'
import WidgetWeek from '@/components/booking-widget/WidgetWeek.vue'
import WidgetTimeLabels from '@/components/booking-widget/WidgetTimeLabels.vue'
import { PublicService } from '@/models/public/bookingWidget.model'
import isBefore from 'date-fns/isBefore'
import { ServiceType } from '@/enums/services'
import { usePublicCompanyLogoQuery } from '@/queries/public/bookingWidget'
import { useRoute } from 'vue-router'
import { ITicketItemDateAvailability } from '@/models/service/serviceTicket.model'
import WidgetTicketDay from '@/components/booking-widget/WidgetTicketDay.vue'
import WidgetTicketHeader from '@/components/booking-widget/WidgetTicketHeader.vue'
/* eslint-disable */

export default /*#__PURE__*/_defineComponent({
  __name: 'WidgetCalendar',
  props: {
  service: {
    type: Object as PropType<PublicService> | null,
    default: null,
  },
  selectedStartDate: {
    type: [Date, null],
    default: null,
  },
  selectedEndDate: {
    type: [Date, null],
    default: null,
  },
  slots: {
    type: Array as PropType<MinimumTimeslot[]>,
    default: () => [],
  },
  selectedSlots: {
    type: Array as PropType<MinimumTimeslot[]>,
    default: () => [],
  },
  days: {
    type: Array as PropType<Date[]>,
    default: () => [],
  },
  housingAvailabilities: {
    type: Array as PropType<CompanyHousingDateAvailability[]>,
    default: () => [],
  },
  ticketAvailabilities: {
    type: Array as PropType<ITicketItemDateAvailability[]>,
    default: () => [],
  },
  selectedCalendar: {
    type: String as PropType<CalendarType> | null,
    default: null,
  },
},
  emits: ['onSlotClick', 'onDaysChange', 'onAddSelectedDate'],
  setup(__props, { emit: emits }) {

const props = __props

const spritePath = require('@/assets/icons/sprite.svg')





const route = useRoute()
const { isMobile } = useBreakpoints()

const { isLoading: isLogoLoading, data: companyLogo } =
  usePublicCompanyLogoQuery(route.query.token as string)

const hoveredDates = ref<[Date | null, Date | null]>([null, null])

const selectedPeriod = computed(() => {
  if (
    props.selectedStartDate &&
    props.selectedEndDate &&
    isBefore(props.selectedStartDate, props.selectedEndDate)
  ) {
    return eachDayOfInterval({
      start: props.selectedStartDate,
      end: props.selectedEndDate,
    })
  }
  if (props.selectedStartDate) {
    return [props.selectedStartDate]
  }
  return []
})
const hoveredPeriod = computed(() =>
  hoveredDates.value[0] &&
  hoveredDates.value[1] &&
  isBefore(hoveredDates.value[0], hoveredDates.value[1])
    ? eachDayOfInterval({
        start: hoveredDates.value[0],
        end: hoveredDates.value[1],
      })
    : [],
)
const timeSlots = computed(() => calculateTimeSlots())

watch(
  () => [props.selectedStartDate, props.selectedEndDate],
  () => {
    hoveredDates.value = [null, null]
  },
)

const handleAddHoveredDate = (day: Date) => {
  const currentStartDate = props.selectedStartDate
  if (!currentStartDate) return

  const currentEndDate = props.selectedEndDate
  if (currentStartDate && currentEndDate) return

  if (isAfter(day, currentStartDate)) {
    hoveredDates.value = [currentStartDate, day]
  } else {
    hoveredDates.value = [day, currentStartDate]
  }
}

const calculateTimeSlots = () => {
  let minDuration: number | undefined
  let minMinutes: number | undefined
  let maxMinutes: number | undefined
  props.slots.forEach((slot: MinimumTimeslot) => {
    const startMinutes = differenceInMinutes(
      new Date(slot.start),
      startOfDay(new Date(slot.start)),
    )
    const endMinutes = differenceInMinutes(
      new Date(slot.end),
      startOfDay(new Date(slot.end)),
    )
    if (props.service.type === ServiceType.EXPERIENCE) {
      const duartion = +slot.duration
      if (minDuration === undefined || duartion < minDuration) {
        minDuration = duartion
      }
    }
    if (minMinutes === undefined || startMinutes < minMinutes) {
      minMinutes = startMinutes
    }
    if (maxMinutes === undefined || endMinutes > maxMinutes) {
      maxMinutes = endMinutes
    }
  })
  const slotDuration = minDuration || 30 // Default 30min
  if (minMinutes && maxMinutes) {
    return _.range(minMinutes, maxMinutes, slotDuration)
  }
  return _.range(0, 24 * 60, slotDuration)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.selectedCalendar)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", {
            class: _normalizeClass(["widget-calendar__container__header", [
          __props.selectedCalendar === _unref(CalendarType).DAY ||
            (__props.selectedCalendar === _unref(CalendarType).WEEK &&
              'widget-calendar__container__header--timeline'),
        ]])
          }, [
            _createVNode(CalendarToolbar, {
              "selected-calendar": __props.selectedCalendar,
              days: __props.days,
              "can-enable-multiday-events-in-timeline": false,
              "can-change-calendar-type": false,
              onOnDaysChange: _cache[0] || (_cache[0] = (days) => emits('onDaysChange', days))
            }, null, 8, ["selected-calendar", "days"]),
            _createVNode(CalendarHeader, {
              "calendar-type": __props.selectedCalendar,
              days: __props.days
            }, null, 8, ["calendar-type", "days"])
          ], 2),
          _createElementVNode("div", _hoisted_3, [
            (__props.selectedCalendar === _unref(CalendarType).DAY && __props.slots.length)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (__props.service.type === _unref(ServiceType).TICKET)
                    ? (_openBlock(), _createBlock(WidgetTicketHeader, {
                        key: 0,
                        "ticket-availabilities": __props.ticketAvailabilities
                      }, null, 8, ["ticket-availabilities"]))
                    : _createCommentVNode("", true),
                  (
              __props.service.type === _unref(ServiceType).TICKET &&
              __props.selectedCalendar === _unref(CalendarType).DAY &&
              __props.slots.length
            )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createVNode(WidgetTimeLabels, { "time-slots": _unref(timeSlots) }, null, 8, ["time-slots"]),
                        _createVNode(WidgetTicketDay, {
                          day: __props.days[0],
                          slots: __props.slots,
                          "time-slots": _unref(timeSlots),
                          "selected-slots": __props.selectedSlots,
                          "ticket-availabilities": __props.ticketAvailabilities,
                          class: "widget-calendar__container__content__timeline__body",
                          onOnClick: _cache[1] || (_cache[1] = (slot) => emits('onSlotClick', slot))
                        }, null, 8, ["day", "slots", "time-slots", "selected-slots", "ticket-availabilities"])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createVNode(WidgetTimeLabels, { "time-slots": _unref(timeSlots) }, null, 8, ["time-slots"]),
                        _createVNode(WidgetDay, {
                          day: __props.days[0],
                          slots: __props.slots,
                          "time-slots": _unref(timeSlots),
                          "selected-slots": __props.selectedSlots,
                          "with-labels": "",
                          class: "widget-calendar__container__content__timeline__body",
                          onOnClick: _cache[2] || (_cache[2] = (slot) => emits('onSlotClick', slot))
                        }, null, 8, ["day", "slots", "time-slots", "selected-slots"])
                      ]))
                ], 64))
              : _createCommentVNode("", true),
            (__props.selectedCalendar === _unref(CalendarType).WEEK && __props.slots.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(WidgetTimeLabels, { "time-slots": _unref(timeSlots) }, null, 8, ["time-slots"]),
                  _createVNode(WidgetWeek, {
                    days: __props.days,
                    slots: __props.slots,
                    "time-slots": _unref(timeSlots),
                    "selected-slots": __props.selectedSlots,
                    class: "widget-calendar__container__content__timeline__body",
                    onOnClick: _cache[3] || (_cache[3] = (slot) => emits('onSlotClick', slot))
                  }, null, 8, ["days", "slots", "time-slots", "selected-slots"])
                ]))
              : _createCommentVNode("", true),
            (
            (__props.selectedCalendar === _unref(CalendarType).WEEK ||
              __props.selectedCalendar === _unref(CalendarType).DAY) &&
            !__props.slots.length
          )
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.$t('bookingWidget.noAvailability')), 1))
              : _createCommentVNode("", true),
            (__props.selectedCalendar === _unref(CalendarType).MONTH)
              ? (_openBlock(), _createBlock(WidgetMonth, {
                  key: 3,
                  days: __props.days,
                  "selected-period": _unref(selectedPeriod),
                  "hovered-period": _unref(hoveredPeriod),
                  availabilities: __props.housingAvailabilities,
                  onOnClick: _cache[4] || (_cache[4] = (day) => emits('onAddSelectedDate', day)),
                  onOnMouseEnter: handleAddHoveredDate
                }, null, 8, ["days", "selected-period", "hovered-period", "availabilities"]))
              : _createCommentVNode("", true)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
          (!_unref(isLogoLoading) && _unref(companyLogo)?.file)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _unref(companyLogo).file,
                alt: "Company logo",
                class: "widget-calendar__container widget-calendar__container__image"
              }, null, 8, _hoisted_9))
            : _createCommentVNode("", true),
          (!_unref(isLogoLoading) && !_unref(companyLogo)?.file)
            ? (_openBlock(), _createElementBlock("svg", _hoisted_10, [
                _createElementVNode("use", {
                  href: `${_unref(spritePath)}#icon-logo-provider`
                }, null, 8, _hoisted_11)
              ]))
            : _createCommentVNode("", true)
        ]))
  ]))
}
}

})